import NewsFetchCoordinator from 'OK/NewsFetchCoordinator';

/**
 * Список листенеров, подписавшихся на пуши/
 *
 * Храним по ключам:
 *
 * Прилетает JSON {'stickers': 'data'} →
 * будем искать коллбеки под ключём 'stickers' и возвращать им ветку 'data'.
 *
 * Формат хранения коллбеков:
 * {
 *     'stickers': [fn1(), fn2(), ...],
 *     ...
 * }
 */
var listeners = {};

function activate() {
    NewsFetchCoordinator.addBlock('PS');
}

function subscribe(propName, applyNews) {
    // подписываемся
    if (!listeners[propName]) {
        listeners[propName] = [];
    }
    listeners[propName].push(applyNews);

    return function() {
        // отписываемся
        var fns = listeners[propName];
        if (fns) {
            var index = fns.indexOf(applyNews);
            if (index >= 0) {
                fns.splice(index, 1);
            }

            if (fns.length === 0) {
                // больше не осталось функций в этом ключе, удалим
                delete listeners[propName];
            }
        }
    };
}

function setNewContent(data) {
    var json = OK.util.parseJsonCorrected(data);

    if (json) {
        // бежим по всем ключам прилетевшего JSON-а
        Object.keys(json).forEach(function(propName) {
            // берём коллбеки, которые подписались на данные этого ключа
            var callbacks = listeners[propName];
            if (callbacks) {
                // данные этого ключа
                var jsonElement = json[propName];

                callbacks.forEach(function (applyNews) {
                    applyNews(jsonElement);
                })
            }
        });
    }
}

export default { activate, subscribe, setNewContent };

export { activate, subscribe, setNewContent };
